import { APIMethod, fetchData } from "@client";

export async function changeProjectDeadlineQuery(uuid, deadline) {
  const data = { uuid, deadline };
  await fetchData("/project/deadline", APIMethod.POST, { data });
}
